import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mock';
import { Award, Shield, Lightbulb, Eye, Star } from 'lucide-react';

const iconMap = [Award, Shield, Lightbulb, Eye, Star];

const WhyUs = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <section id="why-us" className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-72 h-72 bg-amber-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-slate-600/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-amber-500/10 backdrop-blur-sm rounded-full mb-6 border border-amber-500/20">
            <span className="text-amber-400 font-semibold text-sm">{t.whyUs.title}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            {t.whyUs.title}
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            {t.whyUs.subtitle}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.whyUs.items.map((item, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={item.id}
                className="group bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:bg-white/10 hover:border-amber-500/50 transition-all duration-300 hover:-translate-y-2"
              >
                <div className="mb-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center shadow-lg shadow-amber-500/30">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">
                  {item.title}
                </h3>
                <p className="text-slate-300 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;